/*
Copyright (c) 2026 Wind River Systems, Inc.

The right to copy, distribute, modify, or otherwise make use of this software may be licensed only pursuant to the terms of an applicable Wind River license agreement.
*/
import { Component, OnInit } from '@angular/core';
import { AuthService, ConfigService, Config } from '@windriver/authentication';
import { ThemingService } from '@windriver/ui';
import { environment } from '@environment';
import { PortalThemingService } from './services/utils/theming.service';

@Component({
  selector: 'wsn-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent extends PortalThemingService implements OnInit {
  // public title: string;
  public uspConfigLoaded: boolean;
  // public subscriptions: Subscription;

  constructor(
    private themingService: ThemingService,
    private configService: ConfigService,
    private authService: AuthService
  ) {
    super(themingService);
    this.configService.load('./assets/config.json');
  }

  public ngOnInit(): void {
    this.configService.configState.subscribe((config: Config) => {
      if (config && Object.keys(config).length !== 0) {
        // Set auth service URL to enable session verification
        // this.authService.setURL(environment.authMsUrl);
        if (!environment.production && config?.[environment.env]) {
          console.log('local dev ' + environment.env);
          this.configService.configState.next(config[environment.env]);
          Object.assign(config, config[environment.env]);
          config = config?.[environment.env];
        }
        Object.assign(environment, config);
        this.authService.setTozIDValues(config.tozIdHostName, config.tozIdRealmName, config.tozIdClientId);
        this.authService.verifySession();
        this.themingService.load();
        this.uspConfigLoaded = true;
      }
    });
  }
}
